import type { HTMLAttributes, ReactNode } from 'react';

import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'positive' | 'muted' | 'caution' | 'alert';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: ReactNode;
}

// Статус-бейдж с точкой-индикатором. Семантика тона — спокойная, без осуждения.
export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps): JSX.Element {
  return (
    <span className={[styles.badge, styles[tone], className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
